export default "__VITE_ASSET__BRsadJ5P__"